<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <div
    class="deal-id"
    :class="{ small: small }">
    <div class="icon-and-text">
      <span v-if="showIcon"><IconColoredDealID /></span>
      <span
        id="package_details_available_deal_id"
        @click="handlePackageClick">
        {{ dealID }}
      </span>
    </div>
    <input
      id="package_details_available_deal_id_value"
      type="hidden"
      :value="dealID" />

    <button
      v-if="showCopyButton"
      class="btn btn-default copy-button"
      @click="copyToClipboard(dealID, onCopyDealId)">
      {{ $t('actions.copy') }}
    </button>
  </div>
</template>

<script setup lang="ts">
  import { useRouter } from 'vue-router';

  import { IconColoredDealID } from '@/common/icons/colored';
  import DealIDType from '@/common/models/package/DealIDType.enum';
  import { copyToClipboard } from '@/globals';
  import UserNotifications from '@/utils/UserNotifications';
  import i18n from '@/vueI18n';

  // Router
  const router = useRouter();

  interface IDealIDProps {
    dealID: string;
    packageID?: number;
    small?: boolean;
    showCopyButton?: boolean;
    showIcon?: boolean;
    type?: DealIDType;
  }

  // Props
  const props = withDefaults(defineProps<IDealIDProps>(), {
    packageID: -1,
    small: false,
    showCopyButton: true,
    showIcon: false,
    type: DealIDType.Regular,
  });

  // Methods
  const onCopyDealId = async () => {
    UserNotifications.success({
      title: i18n.global.t('messages.copyDealID'),
      message: i18n.global.t('messages.copiedDealIdToClipboard'),
    });
  };

  const handlePackageClick = async (e) => {
    if (props.packageID != null && props.packageID > 0) {
      switch (props.type) {
        case DealIDType.Regular:
          await router.push(`/deals/${props.packageID}`);
          break;
        case DealIDType.Curated:
          await router.push(`/curate/deals/${props.packageID}`);
          break;
        default:
          break;
      }
    } else {
      const dealID = e.target.innerText;
      copyToClipboard(dealID, onCopyDealId);
    }
  };
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables' as *;

  .copy-button {
    margin-left: 2rem;
  }

  .deal-id {
    padding: 0.3rem;
    display: flex;
    align-content: center;
    align-items: center;
    flex-grow: 1;

    .icon-and-text {
      border: solid 0.1rem var(--secondaryColorDesaturated50Lighten30);
      color: var(--secondaryColorLight);
      text-align: center;
      padding: 0.6rem;
      border-radius: 0.6rem;
      flex: 1;
      font-weight: 700;
      font-size: 1.8rem;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      svg {
        height: 2rem;
        width: 2rem;
        margin-right: 0.6rem;
      }
    }

    button {
      float: right;
    }

    &.small {
      .icon-and-text {
        font-size: 1.3rem;
        font-weight: 600;
      }
    }
  }
</style>
